import * as React from 'react'
import { Grid, Typography, CircularProgress } from '@material-ui/core'

import IContest, { ICompetitorLevel } from '../../models/IContest'
import IDictionary from '../../models/IDictionary'
import IOrder from '../../models/IOrder'
import Tickets from './Tickets'
import EntrySelection from './EntrySelection'
import Entry from './Entry'
import Contact from './Contact'
import Payment from './Payment'
import ErrorMessage from '../shared/ErrorMessage'
import { ITicketQuantities } from './Tickets'

interface IOrderFormViewProps {
  contest?: IContest
  order: IOrder
  isSubmitting?: boolean
  selectedLevel: ICompetitorLevel
  errors: IDictionary<boolean>
  errorMessages?: string[]
  validateOrder: IDictionary<boolean>
  validateEntry: IDictionary<boolean>
  onDateChange: (date?: Date) => void
  ticketQuantities: ITicketQuantities
  onTicketsChange: (ticketID: number, quantity: number) => void
  onDivisionsChange: (divisions: string[]) => void
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  onOrderBlur: (e: any) => void
  onEntryBlur: (e: any) => void
  onCloseError: () => void
  onOrderChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >
  onEntryChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >
}

class OrderFormView extends React.Component<IOrderFormViewProps> {
  public renderLoader = () => {
    return (
      <Grid
        container
        style={{ height: 400 }}
        justify="center"
        alignItems="center">
        <CircularProgress size={50} />
      </Grid>
    )
  }

  public render() {
    const {
      contest,
      selectedLevel,
      order,
      onSubmit,
      onDateChange,
      ticketQuantities,
      onTicketsChange,
      onDivisionsChange,
      isSubmitting,
      onOrderChange,
      onEntryChange,
      onOrderBlur,
      onEntryBlur,
      onCloseError,
      errors,
      errorMessages,
      validateEntry,
      validateOrder
    } = this.props
    if (!contest) return this.renderLoader()

    const isFormValid =
      Object.keys(errors).length === 0 && order.lineItems.length > 0

    return (
      <>
        {errorMessages && (
          <ErrorMessage onClose={onCloseError} messages={errorMessages} />
        )}

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          {contest.name}
        </Typography>

        <form onSubmit={onSubmit} noValidate>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Tickets
                ticketQuantities={ticketQuantities}
                onTicketsChange={onTicketsChange}
                events={contest.events}
              />
            </Grid>
            <Grid item xs={12}>
              <EntrySelection
                contest={contest}
                selectedLevel={order.entry ? order.entry.level : undefined}
                onChange={onEntryChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Contact
                order={order}
                onChange={onOrderChange}
                onBlur={onOrderBlur}
                validateOrder={validateOrder}
                invalidEmail={errors.invalidEmail}
                invalidPhone={errors.invalidPhone}
              />
            </Grid>
            {selectedLevel &&
              order.entry && (
                <Grid item xs={12}>
                  <Entry
                    onDateChange={onDateChange}
                    last4SSNInvalid={errors.last4SSNInvalid}
                    birthdateInvalid={errors.birthdateInvalid}
                    selectedLevel={selectedLevel}
                    contest={contest}
                    entry={order.entry}
                    validateEntry={validateEntry}
                    onDivisionsChange={onDivisionsChange}
                    onChange={onEntryChange}
                    onBlur={onEntryBlur}
                  />
                </Grid>
              )}
            <Grid item xs={12} />
          </Grid>

          <Payment
            isDisabled={!isFormValid}
            isSubmitting={isSubmitting}
            lineItems={order.lineItems}
          />
        </form>
      </>
    )
  }
}

export default OrderFormView



// WEBPACK FOOTER //
// ./src/components/contest/OrderFormView.tsx